import { render, staticRenderFns } from "./SysDicSetting.vue?vue&type=template&id=3cb92412&scoped=true"
import script from "./SysDicSetting.vue?vue&type=script&lang=js"
export * from "./SysDicSetting.vue?vue&type=script&lang=js"
import style0 from "./SysDicSetting.vue?vue&type=style&index=0&id=3cb92412&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb92412",
  null
  
)

export default component.exports